import { CheckableList } from 'components/CheckableList/CheckableList'
import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { Button, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IAddOperationPlanTab, IOperationPlanState } from 'types/operationPlans.interface'

export const Scope = ({ setStep, setState, state }: IAddOperationPlanTab) => {
    const handleNext = () => setStep(3)
    const handleBack = () => setStep(1)

    const handleSelect = (v: ISelectValue, n: string) => {
        setState((prev: IOperationPlanState) => {
            if (n === 'zoneScopeLevel') {
                return { ...prev, zoneScopeIds: [], zoneScopeLevel: v }
            }
            return { ...prev, [n]: v }
        })
    }

    const parseZones = (data: any) => {
        return data[zoneTypes[state.zoneScopeLevel?.value]].map((i: any) => ({ label: i.areaName, value: i.id }))
    }

    const zoneTypes = {
        1: 'zones',
        2: 'sections',
        3: 'blocks',
        4: 'pits',
    }

    const handleSelectZoneScopeIds = (ids: ISelectValue[]) => {
        setState((prev: IOperationPlanState) => ({ ...prev, zoneScopeIds: ids.map((id) => ({ label: id.label, value: id.value })) }))
    }

    return <>
        <Flex gap='1rem' >

            <Container>
                <ContainerHeader>
                    <TitleText>Details</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex gap='1rem' mb='16'>
                        <HonestSelectAsyncInput
                            nomarg
                            link='operational/management/site'
                            placeholder='Search locations'
                            name='site'
                            labelText='Site'
                            defaultValue={state?.site?.label}
                            onChange={handleSelect}
                            parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                        />
                        <HonestSelectAsyncInput
                            nomarg
                            link='departments'
                            placeholder='Search department'
                            name='department'
                            labelText='Department'
                            defaultValue={state?.department?.label}
                            onChange={handleSelect}
                            parserFunction={(data: any) =>
                                data.data.map((i: any) => ({ label: i.name, value: i.id }))
                            }
                        />
                    </Flex>
                    <HonestSelectAsyncInput
                        nomarg
                        link='users/basic'
                        name='owner'
                        labelText='Owner'
                        onChange={handleSelect}
                        defaultValue={state.owner?.label}
                        parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, profilePictureUrl: i.getImagePresignedUrl, value: i.id, id: i.accessCardId, role: i.role, gender: i.gender, tierPolicy: i.currentContract?.logisticsInfo?.accomodationTierPolicy }))}
                    />
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Area</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem' >
                        <HonestSelectInput name='zoneScopeLevel' options={zoneLevels} onChange={handleSelect} labelText='Area Level' defaultValue={state.zoneScopeLevel?.value} />
                        {state.zoneScopeLevel?.value && <CheckableList
                            link='zones/areas/non-nested'
                            parserFunction={parseZones}
                            selected={state.zoneScopeIds}
                            onChange={handleSelectZoneScopeIds}
                            selectedLabelText='Selected areas'
                            selectedPlaceholder='No areas selected'
                            listMaxHeight='16rem'
                        />}
                    </Flex>

                </ContainerContent>
            </Container>
        </Flex>

        <Flex gap='1rem' mt='32' justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleNext} >Next</Button>
        </Flex>
    </>
}

// zone levels: 1 - zone, 2 - section, 3 - block, 4 - pit,
const zoneLevels = [
    { label: 'Zone', value: 1 },
    { label: 'Section', value: 2 },
    { label: 'Block', value: 3 },
    { label: 'Pit', value: 4 },
]